import { render, staticRenderFns } from "./SearchTabsContent.vue?vue&type=template&id=0aa06e2c&"
import script from "./SearchTabsContent.vue?vue&type=script&lang=js&"
export * from "./SearchTabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports